<template>
  <card :title="$t('consumer-profile.email-notifications.title')">
    <template #action-bar>
      <el-button
        v-if="!isEditFormShown"
        type="ghost"
        icon="i-pencil-o--16"
        @click="showEditForm"
      >
        {{ $t('action.edit') }}
      </el-button>
    </template>
    <template v-if="isEditFormShown">
      <email-notifications-settings-edit-form
        :value="emailNotificationsSettings"
        @submit="hideEditForm"
        @cancel="hideEditForm"
      />
    </template>
    <template v-else>
      <email-notifications-settings-property-list :value="emailNotificationsSettings" />
    </template>
  </card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/app/components/Card';
import EmailNotificationsSettingsPropertyList from '@/app/components/consumer-profile/EmailNotificationsSettingsPropertyList.vue';
import EmailNotificationsSettingsEditForm from '@/app/components/consumer-profile/EmailNotificationsSettingsEditForm';

export default {
  name: 'EmailNotificationsSettingsCard',
  components: {
    Card,
    EmailNotificationsSettingsPropertyList,
    EmailNotificationsSettingsEditForm
  },
  data() {
    return {
      isEditFormShown: false
    };
  },
  computed: {
    ...mapGetters('app', [
      'emailNotificationsSettings'
    ])
  },
  methods: {
    showEditForm() {
      this.isEditFormShown = true;
    },
    hideEditForm() {
      this.isEditFormShown = false;
    }
  }
};
</script>
